import styled, { css } from "styled-components";
import BasePage from "ui/common/components/layout/BasePage/BasePage";

export const PartnerDetailsPageRoot = styled(BasePage)(
    () => css`
        padding: var(--base-page-padding);
    `,
);
